import { logger } from "@/utils/logger";
import i18n from "@/i18n";
import store from "@/store";
import {
    getAvailableNoticeTemplateList,
    getNoticeTemplateBody,
    getNoticeTemplatePackItems,
    sendMailWithFileReferences,
} from "@/store/services/task/contactMechanism";
import {ComboBox, ComboBoxItem, ContactType, EmailMessage, NoticeTemplateSelectionContext, Template,} from "@/types";
import {downloadFile} from "../../offerService";
import {settings} from "@/settings";
import {api} from "@/auth/api";
import Notify from 'quasar/src/plugins/Notify.js';;
import {contacts} from "@/components/summary-panel/summary";
import { getSignaturesFromMetaData } from "@/commons/eSign";

export const MAX_TRANSMIT_DOCUMENTS = 50;

export function getSelectedDocumentsCountForSend(): number {
    const signatureMethod =
        store.state.taskModule.selectedTask?.variables?.signatureMethod ??
        store.state.demandModule.signatureMethod;
    const selectedIds: string[] = store.getters["templateModule/getSelectedTemplates"] ?? [];
    const templates: Template[] = store.getters["templateModule/getTemplates"] ?? [];
    return selectedIds.filter((processId) =>
        templates.some(
            (t) => t.processId === processId && t.signatureType === signatureMethod
        )
    ).length;
}

export async function getTemplates(currentRoute: string) {
    // const partyInfo = store.state.taskModule.selectedTask.variables.partyInfo;
    // const quoteInfo = store.state.taskModule.selectedTask.variables.quoteInfo;
    logger.debug("selectedTask", store.state.taskModule.selectedTask);
    const signatureMethod = (store.state.taskModule.selectedTask.variables && store.state.taskModule.selectedTask.variables.signatureMethod)  ? store.state.taskModule.selectedTask.variables.signatureMethod : store.state.demandModule.signatureMethod ;
        let request: NoticeTemplateSelectionContext = {
            applicationName: '',
            context: '',
            maxResults: 100,
            dataInfo: '',
            partyInfo: '',
            quoteInfo:'',
            signatureMethod: ''
        }
        switch (currentRoute) {
            case 'demand-edit':
                case "mo-demand-detail":
                request = {
                    applicationName: 'TWDDemo',
                    context: 'offerFinancing',
                    maxResults: 100,
                    dataInfo: '',
                    partyInfo: store.state.demandModule.partyInfo,
                    quoteInfo: store.state.demandModule.quoteInfo,
                    signatureMethod: signatureMethod
                }
                break;
            case 'order-edit':
                request = {
                    applicationName: 'ORDER',
                    context: 'DISTRIBUTION',
                    maxResults: 100,
                    dataInfo: ''
                }
                break;
            case "TaskDetail":
                if (store.getters['taskModule/isTaskModuleOffer']) {
                    request = {
                        applicationName: 'TWDDemo',
                        context: 'offerFinancing',
                        maxResults: 100,
                        dataInfo: '',
                        partyInfo: store.state.demandModule.partyInfo,
                        quoteInfo: store.state.demandModule.quoteInfo,
                        signatureMethod : signatureMethod
                    }
                } else {
                    request = {
                        applicationName: 'ORDER',
                        context: 'DISTRIBUTION',
                        maxResults: 100,
                        dataInfo: ''
                    }
                }
                break;
            case 'third-edit':

                request = {
                    applicationName: 'PARTY',
                    context: 'PARTY',
                    maxResults: 100,
                    dataInfo: '',
                }
                break

        }
    try {
            if(request.context){
                const templates = await getAvailableNoticeTemplateList(request)
                for ( const template of templates ) {
                    template.selected = true
                    if ( template.objectType === 'odm.contactmechanism.noticetemplate.packnoticetemplate' ) {
                        const packItems: any = await getNoticeTemplatePackItems(request, template.resourceUid || '')
                        if ( template.items ) {
                            for ( let i = 0; i < packItems.items.length; i++ ) {
                                packItems.items[i].resourceUid = template.items[i].itemTemplate?.resourceUid;
                                packItems.selected = true;
                                packItems.items[i].selected = true;
                            }
                        }
                        template.isPack = true
                        template.items = [];
                        template.items = packItems.items
                    }
                }
                return templates
            }else{
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                    message: 'Templates not found',
                    color: 'negative'
                })
            }

    } catch (e) {
        return Promise.reject(e)
    }

}

export function handleSendPrintRequest(entityType: string, templateData: any, entityId: string, roleCode: string) {
    switch (entityType) {
        case 'offer':
            return handleOfferSendPrintRequest(templateData, entityId, roleCode)
        case 'order':
            return handleOrderSendPrintRequest(templateData, entityId, roleCode)
        case 'party':
            return handlePartySendPrintRequest(templateData, entityId, roleCode)
    }
}

function handleOfferSendPrintRequest(templateData: any, entityId: string, roleCode: string) {
    let fileCodeList = []
    let reports = []
    if(templateData.length > 0){
        templateData.forEach((main: any) => {
            if(main.isPack && main.selected) {
                main.items.forEach((item: any) => {
                    if(item.selected) {
                        reports.push({
                            "fileCode": item.resourceUid,
                            "dataServiceQuery": {
                                "queryId": "odm-print-select-offer",
                                "offset": 0,
                                "limit": 100,
                                "parameters": {
                                    "offerId": entityId,
                                    "role_code": roleCode
                                },
                            }
                        })
                    }
                })
            }else if(!main.isPack && main.selected) {
                reports.push({
                    "fileCode": main.resourceUid,
                    "dataServiceQuery": {
                        "queryId": "odm-print-select-offer",
                        "offset": 0,
                        "limit": 100,
                        "parameters": {
                            "offerId": entityId,
                            "role_code": roleCode
                        },
                    }
                })
            }
        })
    }else if(templateData.isPack) {
        fileCodeList = templateData.items.filter((item: any) => item.selected)
        fileCodeList.forEach((item: any) => {
            reports.push({
                "fileCode": item.resourceUid,
                "dataServiceQuery": {
                    "queryId": "odm-print-select-offer",
                    "offset": 0,
                    "limit": 100,
                    "parameters": {
                        "offerId": entityId,
                        "role_code": roleCode
                    },
                }
            })
        })
    } else {
        reports.push({
            "fileCode": templateData.resourceUid,
            "dataServiceQuery": {
                "queryId": "odm-print-select-offer",
                "offset": 0,
                "limit": 100,
                "parameters": {
                    "offerId": entityId,
                    "role_code": roleCode
                }
            }
        })
    }


    const fileCodes = new Set();
    reports = reports.filter(item => {
        if (fileCodes.has(item.fileCode)) {
            return false;
        } else {
            fileCodes.add(item.fileCode);
            return true;
        }
    })


    return {
        "reportName": "fileOffer",
        "reportFormat": "PDF",
        reports
    }
}

function handleOrderSendPrintRequest(templateData: any, entityId: string, roleCode: string) {
    let fileCodeList = []
    let reports = []

    if(templateData.length > 0){
        templateData.forEach((main: any) => {
            if(main.isPack && main.selected) {
                main.items.forEach((item: any) => {
                    if(item.selected) {
                        reports.push({
                            "fileCode": item.resourceUid,
                            "dataServiceQuery": {
                                "queryId": "odm-print-select-order",
                                "offset": 0,
                                "limit": 100,
                                "parameters": {
                                    "orderId": entityId,
                                    "role_code": roleCode
                                },
                            }
                        })
                    }
                })
            }else if(!main.isPack && main.selected) {
                reports.push({
                    "fileCode": main.resourceUid,
                    "dataServiceQuery": {
                        "queryId": "odm-print-select-order",
                        "offset": 0,
                        "limit": 100,
                        "parameters": {
                            "orderId": entityId,
                            "role_code": roleCode
                        },
                    }
                })
            }
        })
    }else if(templateData.isPack) {
        fileCodeList = templateData.items.filter((item: any) => item.selected)
        fileCodeList.forEach((item: any) => {
            reports.push({
                "fileCode": item.resourceUid,
                "dataServiceQuery": {
                    "queryId": "odm-print-select-order",
                    "offset": 0,
                    "limit": 100,
                    "parameters": {
                        "orderId": entityId,
                        "role_code": roleCode
                    },
                }
            })
        })
    } else {
        reports.push({
            "fileCode": templateData.resourceUid,
            "dataServiceQuery": {
                "queryId": "odm-print-select-order",
                "offset": 0,
                "limit": 100,
                "parameters": {
                    "orderId": entityId,
                    "role_code": roleCode
                }
            }
        })
    }


    const fileCodes = new Set();
    reports = reports.filter(item => {
        if (fileCodes.has(item.fileCode)) {
            return false;
        } else {
            fileCodes.add(item.fileCode);
            return true;
        }
    })


    return {
        "reportName": "fileOrder",
        "reportFormat": "PDF",
        reports
    }
}

function handlePartySendPrintRequest(templateData: any, entityId: string, roleCode: string) {
    let fileCodeList = []
    let reports = []

    if(templateData.length > 0){
        templateData.forEach((main: any) => {
            if(main.isPack && main.selected) {
                main.items.forEach((item: any) => {
                    if(item.selected) {
                        reports.push({
                            "fileCode": item.resourceUid,
                            "dataServiceQuery": {
                                "queryId": "odm-print-select-party",
                                "offset": 0,
                                "limit": 100,
                                "parameters": {
                                    "partyId": entityId,
                                    "role_code": roleCode
                                },
                            }
                        })
                    }
                })
            }else if(!main.isPack && main.selected) {
                reports.push({
                    "fileCode": main.resourceUid,
                    "dataServiceQuery": {
                        "queryId": "odm-print-select-party",
                        "offset": 0,
                        "limit": 100,
                        "parameters": {
                            "partyId": entityId,
                            "role_code": roleCode
                        },
                    }
                })
            }
        })
    }else if(templateData.isPack) {
        fileCodeList = templateData.items.filter((item: any) => item.selected)
        fileCodeList.forEach((item: any) => {
            reports.push({
                "fileCode": item.resourceUid,
                "dataServiceQuery": {
                    "queryId": "odm-print-select-party",
                    "offset": 0,
                    "limit": 100,
                    "parameters": {
                        "partyId": entityId,
                        "role_code": roleCode
                    },
                }
            })
        })
    } else {
        reports.push({
            "fileCode": templateData.resourceUid,
            "dataServiceQuery": {
                "queryId": "odm-print-select-party",
                "offset": 0,
                "limit": 100,
                "parameters": {
                    "partyId": entityId,
                    "role_code": roleCode
                }
            }
        })
    }


    const fileCodes = new Set();
    reports = reports.filter(item => {
        if (fileCodes.has(item.fileCode)) {
            return false;
        } else {
            fileCodes.add(item.fileCode);
            return true;
        }
    })


    return {
        "reportName": "fileParty",
        "reportFormat": "PDF",
        reports
    }
}

export async function sendPrintRequest(body:any, entityType: string, packTemplateID?: string) {
    let url = ''
    switch (entityType) {
        case 'offer':
            if(!packTemplateID){
                url = `${settings.api_url}/odm-offer/api/1/odm-offer/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.offerId}/${body.reports[0].fileCode}/`;
            }else{
                url = `${settings.api_url}/odm-offer/api/1/odm-offer/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.offerId}/${packTemplateID}/`;
            }
            break
        case 'order':
            if(!packTemplateID){
                url = `${settings.api_url}/odm-order/api/1/odm-order/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.orderId}/${body.reports[0].fileCode}/`;
            }else{
                url = `${settings.api_url}/odm-order/api/1/odm-order/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.orderId}/${packTemplateID}/`;
            }
            break
        case 'party':
            if(!packTemplateID){
                url = `${settings.api_url}/odm-party/api/1/odm-party/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.partyId}/${body.reports[0].fileCode}/`;
            } else {
                url = `${settings.api_url}/odm-party/api/1/odm-party/generatedDocument/requestNew/${body.reports[0].dataServiceQuery.parameters.partyId}/${packTemplateID}/`;
            }
            break
    }
    return (await api().post(url, body)).data
}

export async function checkDocumentGenerated(entityId: string, templateName: string | undefined, entityType: string, processId?: string) {
    let url = ''
    switch (entityType) {
        case 'offer':
            if(!processId){
                url = `${settings.api_url}/odm-offer/api/1/odm-offer/generatedDocument/checkDocumentGenerated/${entityId}/${templateName}/`;
            }else{
                url = `${settings.api_url}/odm-offer/api/1/odm-offer/generatedDocument/checkDocumentGenerated/${processId}/`;
            }
            break
        case 'order':
            if(!processId){
                url = `${settings.api_url}/odm-order/api/1/odm-order/generatedDocument/checkDocumentGenerated/${entityId}/${templateName}/`;
            }else{
                url = `${settings.api_url}/odm-order/api/1/odm-order/generatedDocument/checkDocumentGenerated/${processId}/`;
            }
            break
        case 'party':
            if(!processId){
                url = `${settings.api_url}/odm-party/api/1/odm-party/generatedDocument/checkDocumentGenerated/${entityId}/${templateName}/`;
            }else{
                url = `${settings.api_url}/odm-party/api/1/odm-party/generatedDocument/checkDocumentGenerated/${processId}/`;
            }
            break
    }
    return (await api().get(url)).data
}

export async function getMail(entity: any, entityType: string): Promise<ComboBox> {
    const comboEmail: ComboBoxItem[] = []
    if(entityType === 'offer'){
        entity.associatedParties?.forEach((p: any) => {
            // Both orgs and persons should loop correspondents.
            p.associatedParty?.third?.correspondents.forEach((b:any) => {
                b.contactCorrespondent.filter((c:any) =>
                    c.contactMechanism.type?.id === ContactType.EMAIL_CONTACT)
                    .forEach((c:any) => {
                        const emailLabel = b.qualificationType?.type?.value
                        comboEmail.push({
                            value: `${c.contactMechanism.emailAddress}`,
                            label: `${emailLabel}: ${c.contactMechanism.emailAddress}`,
                        })
                    })
            })
            if (p.associatedParty?.third?.type.id === 'party-FrenchPerson' ){
                p.associatedParty?.third?.contacts.filter((c:any) => c.contactMechanism.type.id === 'EMAIL_CONTACT')
                    .forEach((c:any) => {
                        const emailLabel = `demand.party.roles.${p.role_code}`
                        comboEmail.push({
                            value: `${c.contactMechanism.emailAddress}`,
                            label: `${i18n.global.t(emailLabel)}: ${c.contactMechanism.emailAddress}`,
                        })
                    })
            }
        })
    } else if (entityType === 'order'){
        entity.orderParties?.forEach((p: any) => {
            if (p.orderParty?.third?.type.id === 'party-FrenchOrganization'
                ||  p.orderParty?.third?.type.id === 'party-FrenchPerson' ){
                p.orderParty?.third?.person.contacts.forEach((b:any) => {
                    if(b.contactMechanism.type.id === 'EMAIL_CONTACT'){
                        const emailLabel = `demand.party.roles.${p.orderParty.role.resourceUid}`
                        comboEmail.push({
                            value: `${b.contactMechanism.emailAddress}`,
                            label: `${i18n.global.t(emailLabel)}: ${b.contactMechanism.emailAddress}`,
                        })
                    }
                })
            }
        })
    } else if(entityType === 'party'){
        const isCustomer = entity.person?.roles
        if(isCustomer.length > 0){
            entity.person?.contacts?.map((p: any) => {
                if(p.contactMechanism.type.id === ContactType.EMAIL_CONTACT){
                    const emailLabel = 'demand.party.roles.CUSTOMER'
                    comboEmail.push({
                        value: `${p.contactMechanism.emailAddress}`,
                        label: `${i18n.global.t(emailLabel)}: ${p.contactMechanism.emailAddress}`,
                    })
                }
            })
        }

    }

    return {items: comboEmail};
}

export type DocumentEmailSendOptions = {
    to: string[];
    cc?: string[];
    emailBodyHtml?: string;
    lizfiNumber?: string;
    offerNumber?: string;
    externalReference?: string;
    clientName?: string;
    templateResourceUid?: string;
};

export async function sendMailWithAllDocument(
    mailOptions: DocumentEmailSendOptions,
    responses?: any,
    selectedFilesToSign?: any
) {
    const offer = store.state.taskModule.offer ?? store.state.demandModule.offer;
    if (!offer || !mailOptions?.to?.length) {
        return;
    }

    const attachments = [];
    const { associatedParties } = offer;
    for (const response of responses ?? []) {
        const originalDoc = selectedFilesToSign.filter(
            (item: any) => item.fileId === response.resourceUid
        )[0];
        if (!originalDoc) {
            continue;
        }
        const fileResourceUid = response.resourceUid;
        attachments.push({
            objectType: "odm.contactmechanism.emailattachment",
            systemUid: "odm-filemngt",
            resourceUid: fileResourceUid,
            attachment: {
                objectType: "odm.filemngt.file",
                systemUid: "odm-filemngt",
                resourceUid: fileResourceUid,
            },
            label: originalDoc.fileName,
            originalFileName: originalDoc.fileName,
            format: "application/pdf",
        });
    }

    const to = mailOptions.to;
    const cc = (mailOptions.cc ?? []).filter(Boolean);

    const body: EmailMessage = {
        objectType: "odm.contactmechanism.communicationrequest.emailmessage",
        clientApplication: {
            systemUid: "odm-contactmechanism",
            objectType: "odm.contactmechanism.contactmechanismclient",
            resourceUid: "ApplicationClient",
        },
        emailTemplate: {
            objectType: "odm.contactmechanism.emailtemplate",
            systemUid: "odm-contactmechanism",
            resourceUid: mailOptions.templateResourceUid ?? "TEMPLATE_Notif_SM",
        },
        parameters: {
            signatory_name: to.join(", "),
            signatory_email: to.join(";"),
            ...(cc.length > 0 ? { signatory_cc: cc.join(";") } : {}),
            ...(mailOptions.emailBodyHtml ? { email_body: mailOptions.emailBodyHtml } : {}),
            ...(mailOptions.lizfiNumber ? { lizfi_number: mailOptions.lizfiNumber } : {}),
            ...(mailOptions.offerNumber ? { offer_number: mailOptions.offerNumber } : {}),
            ...(mailOptions.externalReference
                ? { external_reference: mailOptions.externalReference }
                : {}),
            ...(mailOptions.clientName ? { client_name: mailOptions.clientName } : {}),
        },
        businessData: null,
        relatedObjects: null,
        attachments,
    };

    await sendMailWithFileReferences(body)
        .then(() =>
            Notify.create({
                timeout: 10000,
                actions: [{ icon: "close", color: "white" }],
                message: i18n.global.t("task.printDocument.message"),
                color: "positive",
            })
        )
        .catch(() =>
            Notify.create({
                timeout: 5000,
                message: i18n.global.t("task.printDocument.oversizedDocuments"),
                color: "negative",
            })
        );
}

export async function getNoticeBody(): Promise<string>{
    const result = await getNoticeTemplateBody()
    return result.body
}
